import {
  GET_SLIDERS_PENDING,
  GET_SLIDERS_FULFILLED,
  GET_SLIDERS_REJECTED,
  FETCH_ACTIVE_SLIDERS_PENDING,
  FETCH_ACTIVE_SLIDERS_FULFILLED,
  FETCH_ACTIVE_SLIDERS_REJECTED,
  SLIDER_COLLECTION_PENDING,
  SLIDER_COLLECTION_FULFILLED,
  SLIDER_COLLECTION_REJECTED
} from "../actions/slider";

const initialState = {
  fetching: false,
  sliders: null,
  fetchingActiveSliders: false,
  activeSliders: null,
  sliderCollectionFetching: false,
  sliderCollection: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SLIDERS_PENDING:
      return {
        ...state,
        fetching: true
      };
    case GET_SLIDERS_FULFILLED:
      return {
        ...state,
        fetching: false,
        sliders: action.payload
      };
    case GET_SLIDERS_REJECTED:
      return {
        ...state,
        fetching: false
      };
    case FETCH_ACTIVE_SLIDERS_PENDING:
      return {
        ...state,
        fetchingActiveSliders: true
      };
    case FETCH_ACTIVE_SLIDERS_FULFILLED:
      return {
        ...state,
        fetchingActiveSliders: false,
        activeSliders: action.payload
      };
    case FETCH_ACTIVE_SLIDERS_REJECTED:
      return {
        ...state,
        fetchingActiveSliders: false
      };
    case SLIDER_COLLECTION_PENDING:
      return {
        ...state,
        sliderCollectionFetching: true,
        sliderCollection: null
      };
    case SLIDER_COLLECTION_FULFILLED:
      return {
        ...state,
        sliderCollectionFetching: false,
        sliderCollection: action.payload
      };
    case SLIDER_COLLECTION_REJECTED:
      return {
        ...state,
        sliderCollectionFetching: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/sliderReducer.js